import { forwardRef, useImperativeHandle, useRef } from "react";
import PathAnimation from "../pathAnimation";
import Video from "../video";
import styles from "./index.module.css";
import { animated, useSpring } from "@react-spring/web";

import PreAndNext from "../preAndNext";
import Subscribe from "../subscribe";
import BuyCard from "../buyCard";
import Detail from "../detail";

const Poster = (
  {
    movieData,
    handleStartPlay,
    handlePlayVisble,
    handlePlayHidden,
    handlePlayToggle,
    currentIndex,
    lastIndex,
    setLoadProgressState,
    handleClosePlay,
    index,
    playVideoProps,
    closeVideoProps,
    dashoffsetProps,
    innerWidth,
    innerHeight,
    isMobile,
    videoSpringStyles,
    coverSpringStyles,
    coverClipPathSpring,
    handleNextIndex,
    handleLastIndex,
    movieNameStyles,
    setInputFocus,
    setInputValue,
    inputStatus,
    onSubmit,
    inputFocus,
    inputValue,
    detailIsRender
  },
  ref
) => {
  const videoChildRef = useRef();
  const detailChildRef = useRef()
  const ctnRef = useRef(null);

  useImperativeHandle(ref, () => {
    return {
      closeVideo,
      playVideo,
    };
  });
  const [detailSpringStyles, setDetailSpringStyles] = useSpring(() => {
    return {
      display: "none",
    };
  });

  const playVideo = (inHomePage = true) => {
    if (inHomePage) {
      setDetailSpringStyles.start(() => {
        return {
          display: "grid",
          delay: 1400,
          onStart: () => {
            if (!isMobile) {
              videoChildRef.current.playVideo();
            }
          },
        };
      });
      if (isMobile) {
        videoChildRef.current.playVideo();
      }
      playVideoProps();
    } else {
      setDetailSpringStyles.start(() => {
        return {
          display: "grid",
        };
      });
      if (!isMobile) {
        handlePlayToggle("play");
      }
      // videoChildRef.current.playVideo();
    }

  };

  const closeVideo = (inHomePage = true) => {
    if (inHomePage) {
      setDetailSpringStyles.start(() => {
        return {
          display: "none",
        };
      });
      closeVideoProps();
      videoChildRef.current.pauseVideo();
    } else {
      setDetailSpringStyles.start(() => {
        return {
          display: "none",
        };
      });

      videoChildRef.current.pauseVideo();
    }
  };

  const pauseVideo = () => {
    videoChildRef.current.pauseVideo();
  };

  console.log("组件:Poster 重新渲染");
  return (
    <div className={styles.ctn} ref={ctnRef}>
      <div className={styles.posterCtn}>
        <animated.div
          className={`${styles.posterImgCtn}`}
          style={{
            // backgroundImage: `url(${movieData.posterSrc})`,
            ...coverSpringStyles,
            "--effect-dashoffset": dashoffsetProps,
            "--effect-offset-top": coverClipPathSpring.clipPathTop,
            "--effect-offset-bottom": coverClipPathSpring.clipPathBottom,
          }}
        >
          <PathAnimation
            movieData={movieData}
            movieNameStyles={movieNameStyles}
            onClick={() => {
              // handleStartPlay(plyr.current);
              playVideo(true);
            }}
          />
          <img src={movieData.posterSrc} alt="" />
        </animated.div>
        <Video
          movieData={movieData}
          handlePlayVisble={handlePlayVisble}
          handlePlayHidden={handlePlayHidden}
          handlePlayToggle={handlePlayToggle}
          currentIndex={currentIndex}
          lastIndex={lastIndex}
          setLoadProgressState={setLoadProgressState}
          handleClosePlay={handleClosePlay}
          videoSpringStyles={videoSpringStyles}
          closeVideo={closeVideo}
          innerWidth={innerWidth}
          innerHeight={innerHeight}
          isMobile={isMobile}
          ref={videoChildRef}
          index={index}
        />
      </div>
      <animated.div
        style={{ ...detailSpringStyles }}
        className={`${styles.detailCtn} sm5s-ssp-detail-ctn-${index}`}
      >
        <Detail
          index={index}
          isMobile={isMobile}
          handleNextIndex={handleNextIndex}
          handleLastIndex={handleLastIndex}
          pauseVideo={pauseVideo}
          playVideo={playVideo}
          setInputFocus={setInputFocus}
          movieData={movieData}
          inputFocus={inputFocus}
          inputValue={inputValue}
          inputStatus={inputStatus}
          setInputValue={setInputValue}
          onSubmit={onSubmit}
          currentIndex={currentIndex}

        />
      </animated.div>
    </div>
  );
};

export default forwardRef(Poster);
